import ErrorBox from '@components/common/ErrorBox';
import Button from '@ui/button/Button';
import DwFormField from '@ui/formfield/DwFormField';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import MonclerCollectionCheckbox from '@moncler/components/newsletter/MonclerCollectionCheckbox';
const NewsletterForm = ({ email, onSubmitSuccess, cookiepage, isPopup }) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    useEffect(() => {
        let val = {};
        api.getForm('newsletters-subscribe', val).then((data) => {
            setInitialValues(Object.assign(Object.assign({}, val), { newslettersEmailSubscription: email }));
            setFormdef(data);
        });
    }, []);
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'newsletters-subscribe');
    };
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .submitNewsletter(values, formdef)
            .then((data) => {
            if (data.success) {
                //save preferences in analytics
                let flags = [];
                let tempValues = values;
                for (const property in tempValues) {
                    if (tempValues[property] && property.includes('addtoemaillist')) {
                        let properyCleanedForGTM = '';
                        //OE-12611 Delocalization label
                        if (property == 'addtoemaillistmen') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.men.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistwomen') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.women.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistchildren') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.children.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistgrenoble') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.grenoble.profile').toLowerCase();
                        }
                        else if (property == 'addtoemaillistgenius') {
                            properyCleanedForGTM = t('description.checkbox.emailsignup.genius.profile').toLowerCase();
                        }
                        flags.push(properyCleanedForGTM);
                    }
                }
                analytics.newsletterSubscription(t('button.submitanalytics'), flags, isPopup);
                onSubmitSuccess();
            }
            else {
                // setErrors(data.error);
            }
        })
            .catch((e) => setErrors([e]));
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", null,
        React.createElement(Form, { onSubmit: onSubmit, initialValues: initialValues, validate: validate, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(DwFormField, { def: formdef, name: "newslettersEmailSubscription", type: "email" }),
                React.createElement("div", { className: "newsletter-modal__gender-wrapper mt-12 mb-16" },
                    React.createElement(DwFormField, { def: formdef, name: "gender", type: "radio" })),
                values['gender'] && (React.createElement("div", { className: "newsletter-modal__radio-wrapper" },
                    React.createElement("p", null, t('preferences.notifymeabout')),
                    React.createElement("div", { className: "checkbox-wrapper" },
                        React.createElement("div", { className: "newsletter-flag mb-28" },
                            React.createElement(MonclerCollectionCheckbox, { formdef: formdef, formInstance: form }))),
                    React.createElement(ErrorBox, { errors: errors }))),
                React.createElement("div", { className: "newsletter-modal__privacy-flag" },
                    React.createElement(DwFormField, { def: formdef, name: "personalInfoFlag", type: "checkbox" })),
                React.createElement("p", { className: "newsletter-modal__required-label" }, t('label.required')),
                React.createElement("div", { className: "row button-row" },
                    React.createElement(Button, { type: "submit", cls: ['button--primary'] }, t('button.submit'))),
                React.createElement("p", { className: "newsletter-modal__legal-label" },
                    t('preferences.newsletterterms1'),
                    ' ',
                    React.createElement("a", { href: cookiepage, target: "_blank" }, t('preferences.privacysettings.privacyandcookiepolicy')),
                    ' ',
                    t('preferences.newsletterterms2')))) })));
};
export default NewsletterForm;
